module.exports = __webpack_public_path__ + "img/filter_add.7181d775.svg";